import { useMutation } from "react-query";
import { updateCameraType2 } from "../../../../../actions/Utilities/CameraType2";
import { ICameraType2 } from "../types";
import { toast } from "components/toastNotification";
import { cameraType2ReFetching, editStateCameraType2 } from "../atoms/atoms";
import { useRecoilState, useSetRecoilState } from "recoil";

const useEditCameraType2 = () => {
  const setActionEditState = useSetRecoilState(editStateCameraType2);
  const [isReFetching, setIsReFetching] = useRecoilState(cameraType2ReFetching);
  const { mutate } = useMutation(
    (Data: ICameraType2) => updateCameraType2(Data),
    {
      onSuccess: (res) => {
        if (typeof res == "object") {
          toast.fire(
            "Updating Camera Type 2 failed",
            `${res.Message}`,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Camera Type 2 Updated Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Camera Type 2 Updated Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Updating Camera Type 2 failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Updating Camera Type 2 failed ",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Updating Camera Type 2 failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Updating Camera Type 2 failed", `${res}`, "error");
          }
        }
        // Redirect to View
        setActionEditState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire("Update Camera Type 2 failed", `Error: ${error}`, "error");
      },
    }
  );
  return mutate;
};

export default useEditCameraType2;
